import React, { useState, useEffect, useRef } from "react";

import FooterNew from "../NavBar/FooterNew";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { pdfjs } from "react-pdf";
import axios from "axios";
import base_url from "../../api/bootapi";
import attachmenturl from "../../api/attachmenturl";

import { useParams, Link, useNavigate, useLocation } from "react-router-dom";
import { Button } from "reactstrap";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";

import { useForm } from "react-hook-form";

import Nav from "../NavBar/Nav";
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";
import PdfCanvasView from "./RenderPdf";

pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;

export default function TourItineraryPdf() {



  const navigate = useNavigate();




  const [backdropopen, setbackdropopen] = useState(false);



  const [tourpdfurl, settourpdfurl] = useState("");
  const [tripItineraryUrl, setTripItineraryUrl] = useState("");
  const [tourstatus, settourstatus] = useState("");

  console.log("first ====> ", tripItineraryUrl)


  const [fullPackage, setFullPackage] = useState(null);
  const [accommodation, setAccommodation] = useState(null);
  const [singleRoomCost, setSingleRoomCost] = useState(null);
  const [insurancePrice, setInsurancePrice] = useState(null);
  const [isPastTour, setIsPastTour] = useState(true);



  const isMobile = window.innerWidth <= 768;

  const params = useParams();

  const tour_pdf_id = params?.tour_pdf_name;

  const [tourId, setTourId] = useState(null)

  const location = useLocation();

  // const tour_pdf_id = localStorage.getItem("tour_pdf_id");


  const tourName = location.state?.tour_names || null;
  const [tourNewName, setTourNewName] = useState(null)
  const [tourNote, setTourNote] = useState(null)


  useEffect(() => {
    getAllTourList();
  }, [tour_pdf_id]);

  const getAllTourList = () => {
    setbackdropopen(true);
    axios
      .get(`${base_url.api1}/tourapp/get_trip?url_name=${tour_pdf_id}`)
      .then((response) => {
        console.log("tour details", response.data.Tour);
        setFullPackage(response.data.Tour[0].full_package_price);
        setAccommodation(response.data.Tour[0].accommodation_only_price);
        setSingleRoomCost(response.data.Tour[0].single_room_cost);
        setInsurancePrice(response.data.Tour[0].insurance_price);

        setTourNewName(response.data.Tour[0].tour_names);
        setTourNote(response.data.Tour[0].tour_long_descript)

        // "tour_status": "InActive",
        const tour_id = response.data.Tour[0].id
        setTourId(tour_id);

        if (response.data.Tour[0].tour_status === "Active") {
          setIsPastTour(false);
        }

        axios.get(`${base_url.api1}/tourapp/trip_list`, {}).then(
          (response) => {
            //console.log("100", response.data.tour);
            // setupcomingTourName(response.data.tour);
            document.getElementById("myForm").reset();
            // Find the object with matching id
            const matchingObject = response?.data?.tour?.find(
              (obj) => obj.id == tour_id
            );

            // Check if a matching object was found
            if (matchingObject) {
              //console.log("Matching tour_names:", matchingObject);
              setTripItineraryUrl(matchingObject.itinerary_details)
              settourpdfurl(matchingObject.tour_details);
              settourstatus(matchingObject.tour_status);
            }
            setbackdropopen(false);
          },
          (error) => {
            settourpdfurl(null);
            setbackdropopen(false);

            //console.log(JSON.stringify(error.response.data));
          }
        );
      })
      .catch((err) => {
        setbackdropopen(false);
      });
  };




  const fullURL = tourpdfurl ? `${attachmenturl}${tourpdfurl}` : null;
  const fullItinerary = tripItineraryUrl ? `${attachmenturl}${tripItineraryUrl}` : null;
  console.log(fullItinerary)


  const [file, setFile] = useState(null);


  useEffect(() => {
    if (!tourpdfurl) return;

    const fullURL = tourpdfurl ? `${attachmenturl}${tourpdfurl}` : null
    const loadPdf = async () => {
      const response = await fetch(fullURL, { mode: "cors" });
      const blob = await response.blob();
      setFile(URL.createObjectURL(blob));
    };

    loadPdf();
  }, [tourpdfurl]);



  const [numPages, setNumPages] = useState(null);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };
  // const printIframe = (id) => {
  //     //console.log(id);
  //     const iframe = document.frames
  //         ? document.frames[id]
  //         : document.getElementById(id);
  //     const iframeWindow = iframe.contentWindow || iframe;

  //     iframe.focus();
  //     iframeWindow.print();
  //     return false;
  // };

  const pdfToImage = async (pdfUrl) => {
    const loadingTask = pdfjs.getDocument(pdfUrl);
    const pdf = await loadingTask.promise;
    const page = await pdf.getPage(1); // Render the first page, or loop if multiple pages are needed

    const viewport = page.getViewport({ scale: 1.5 });
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    canvas.height = viewport.height;
    canvas.width = viewport.width;

    const renderContext = {
      canvasContext: context,
      viewport: viewport,
    };
    await page.render(renderContext).promise;

    // Convert canvas to an image URL
    return canvas.toDataURL();
  };

  const printIframe = async (pdfUrl, priceHTML) => {
    try {
      // Set loading state
      setbackdropopen(true);

      // Convert the PDF to an image
      const imageUrl = await pdfToImage(pdfUrl);

      // Create an invisible iframe
      const iframe = document.createElement("iframe");
      iframe.style.position = "absolute";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "none";
      document.body.appendChild(iframe);

      // Get the iframe's document
      const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

      // Write the content to the iframe's document
      iframeDoc.open();
      iframeDoc.write(`
        <html>
          <head>
            <style>
              body {
                display: flex;
                flex-direction: column;
                align-items: center;
                padding: 20px;
              }
              img {
                width: 100%;
                max-height: 1140px;
                object-fit: contain;
                border: 2px solid black;
              }
              .price-container {
                margin-top: 20px;
              }
            </style>
          </head>
          <body>
            <img src="${imageUrl}" />
          
          </body>
        </html>
      `);
      iframeDoc.close();
      //   <div class="price-container">
      //   ${priceHTML}
      // </div>
      // Wait for the content to be fully loaded and then print
      iframe.onload = () => {
        setbackdropopen(false);
        iframe.contentWindow.focus();
        iframe.contentWindow.print();

        // Remove the iframe after printing
        setTimeout(() => {
          document.body.removeChild(iframe);
        }, 1000);
      };
    } catch (error) {
      // Handle any errors
      setbackdropopen(false);
      console.error("Error occurred while printing the iframe:", error);
    }
  };

  // const printIframe = (id, divcontents) => {
  //     var content = document.getElementById(divcontents); // Use the passed divcontents variable
  //     var pri = document.getElementById(id).contentWindow; // Use the passed id variable
  //     pri.document.open();
  //     pri.document.write(content.innerHTML);
  //     pri.document.close();
  //     pri.focus();
  //     pri.print();
  // };

  const handleEnrollmentClick = () => {
    // Navigate to the specified pathname on button click
    navigate({
      pathname: `//enrollment/${tourId}/`,
      state: { tour_names: tourName },
    });
  };

  const containerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);
  useEffect(() => {
    const handleResize = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div style={{ backgroundColor: "#F5F6FA" }}>
      <React.Fragment>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={backdropopen}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Nav />

        <div className="container">


          <div style={{ flex: 1, position: "relative", }} className="mobile-tour-trip-pdf itinerary-pdf">

            <h2 style={{ textAlign: "center", fontWeight: 600, fontSize: '20px' }}>Itinerary</h2>
            {tourNewName && <h3 style={{ textAlign: "center", fontWeight: 600, fontSize: '20px', marginBottom: '2rem' }}>{tourNewName}</h3>}


            {tripItineraryUrl == null ? (
              <img
                src="No_image_available.png"
                width="200"
                height="200"
                alt="No image available"
              />
            ) : (
              <div style={{ minHeight: isMobile ? "initial" : '1000px' }}>

                {
                  isMobile ? <PdfCanvasView fileUrl={fullItinerary} />
                    :
                    fullItinerary && <iframe
                      id="tourpdf"
                      src={`${fullItinerary}#view=FitH`}
                      width="100%"
                      height="1150px"
                      style={{ border: 'none' }}
                    />
                }

              </div>

            )}





          </div>






        </div>
        <FooterNew />
      </React.Fragment>
    </div>
  );
}
